import { USUARIO } from "@pcgerente-node/pcg-comun/dist/DTOs"
import axios, { AxiosResponse } from "axios"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import {IApiResponse} from "@pcgerente-node/pcg-comun";
import { numerosNaturales } from "../../Utils/regex"
import { ObtenerUsuarioPorId, guardarUsuarioEnRedux } from "../../redux/actions/actionAuth"
import { getAllCities } from "../../redux/actions/actionsCrear"
import { baseURL, headers } from "../../redux/helpersRedux"
import { RootState, useAppDispatch } from "../../redux/store"
import Loading from "../helpers/Loading/Loading"
import { RolesUsuarios } from "../useAuth/useAuth"
import ModalSuccessChanges from "./ModalSuccessChanges"

const ContentPerfil = () => {

    //estados locales
    const [infoUser, setInfoUser] = useState(new USUARIO())

    const [msgSubmit, setMsgSubmit] = useState("") 

    //Informacion de redux
    const ciudadesStore = useSelector((state: RootState) => state.crear.ciudadesCrear)
    const usuarioVM = useSelector((state: RootState) => state.auth.usuarioActual)
    const idUsuario = usuarioVM._ItemActivo?.id

    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    
    useEffect(() => {
        ObtenerDatosUsuario(idUsuario)
        dispatch(getAllCities()) 
    },[])

    function ObtenerDatosUsuario(_idUsuario: number){
        ObtenerUsuarioPorId(_idUsuario).then(
            (response) =>{
                console.log(response)
                setInfoUser(response)
            } 
        ).catch(
            () => {
                alert("Usted no se encuentra logeado")
                navigate("/home")
            }
        ) 
    }

    const handleInfo = (e: React.ChangeEvent<HTMLInputElement| HTMLSelectElement> , type: string) => {
        setMsgSubmit("")
        if(type === "nombre" && e.target.value.length <99){
            setInfoUser({
             ...infoUser,
             nombre: e.target.value.toUpperCase()   
            })
        }

        if(type === "direccion" && e.target.value.length <190){
            setInfoUser({
             ...infoUser,
             direccion: e.target.value.toUpperCase()   
            })
        }

        if(type === "telefono" && (numerosNaturales(e.target.value) || e.target.value ===   "")) {
            if(e.target.value.length <= 10){
                setInfoUser({
                    ...infoUser,
                    telefono: e.target.value
                })
            }
        }

        if(type === "email" && e.target.value.length <=50){
            setInfoUser({
                ...infoUser,
                email: e.target.value
            })
        }

        if(type === "ciudad" && e.target.value !== "none"){
            const coincidencia = ciudadesStore.info.find(c => c.id === Number(e.target.value))
            if( coincidencia){   
                setInfoUser({
                    ...infoUser,
                    idCiudad: Number(e.target.value),
                    CIUDAD: coincidencia
                })
            }
        }  
    }


    const guardarCambios = async() =>{
        let actualError = ""
        if(infoUser.telefono && infoUser.telefono.length<6){
            actualError ="Error: El número de teléfon debe tener al menos 6 digitos"
        }
        else if(infoUser.direccion && infoUser.direccion.length<10){
            actualError ="Error: La dirección es muy corta"
        }
        else if(isNaN(Number(infoUser.idCiudad))){
            actualError = "Error: No se ha elejido una ciudad"
        }

        const botonGuardar = window.document.getElementById('multiple-reset') as HTMLButtonElement
        if(botonGuardar){
            botonGuardar.disabled = true

            if(actualError){
                setMsgSubmit(actualError)
            }
            else{
                const response  = await cambiarInformacionUsuario(infoUser.id, infoUser)
                if(response.error){
                    setMsgSubmit(`Error: ${response.error}`)
                }else{
                    dispatch(guardarUsuarioEnRedux(response.companion!!))
                    setMsgSubmit("La información ha sido actualizada")
                }
            }
            botonGuardar.disabled = false
    } 
  
    }
    return (
        <>
             <div id="content" className="main-content">
        {infoUser.id>0 && ciudadesStore.loading === false?
                <div className="layout-px-spacing">

                    <div className="account-settings-container layout-top-spacing">

                        <div className="account-content">
                            <div className="scrollspy-example" data-spy="scroll" data-target="#account-settings-scroll" data-offset="-100">
                                <div className="row">
                                    <div className="col-xl-12 col-lg-12 col-md-12 ">
                                        <form id="general-info" className="section general-info" onSubmit={(e) => e.preventDefault()}>
                                            <div className="info">
                                                <h5 className="">Información General</h5>
                                                <div className="row">
                                                    <div className="col-lg-12 mx-auto">
                                                        <div className="row">

                                                            <div className="col-xl-12 col-lg-12 col-md-8 mt-md-0 mt-4">
                                                                <div className="form">
                                                                    <div className="row">
                                                                        <div className="col-sm-8">
                                                                            <div className="form-group ml-2">
                                                                                <label htmlFor="fullName">Nombres Completos</label>
                                                                                <input type="text"
                                                                                    className="form-control"
                                                                                    id="fullName"
                                                                                    placeholder="Ingrese sus nombres"
                                                                                    value={infoUser.nombre || ""} 
                                                                                    onChange={(e) => handleInfo(e, "nombre") }
                                                                                    
                                                                                    />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>

                                    <div className="col-xl-12 col-lg-12 col-md-12 layout-spacing">
                                        <form id="contact" className="section contact">
                                            <div className="info">
                                                <h5 className=""> Datos de Contacto</h5>
                                                <div className="row">
                                                    <div className="col-md-12 mx-auto">
                                                        <div className="row pl-2 pr-2">
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label htmlFor="address">Dirección</label>
                                                                    <input type="text" 
                                                                        className="form-control mb-4"
                                                                        id="address"
                                                                        placeholder="Ingrese su dirección"
                                                                        value={infoUser.direccion || ""} 
                                                                        onChange={(e) => handleInfo(e, "direccion") }
                                                                        />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label htmlFor="location">Ciudad Origen Predeterminada</label>
                                                                    <select 
                                                                    className="form-control" 
                                                                    id="country"
                                                                    value={infoUser.idCiudad||0}
                                                                    /*CUIDADO: Puede interferir con la lógica de pago con los conductores*/ 
                                                                    disabled = {usuarioVM.rolUsuario === RolesUsuarios.CONDUCTOR}
                                                                    onChange={(e) => handleInfo(e, "ciudad")}
                                                                    >
                                                                    <option  value={0}  hidden>Escoge una Ciudad</option>
                                                                        {ciudadesStore.info.length>1 && ciudadesStore.info.map(ciudad =>
                                                                            <option value={ciudad.id} key={ciudad.id}>{ciudad.nombre}</option>
                                                                        )}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label htmlFor="phone">Teléfono</label>
                                                                    <input type="text" 
                                                                    className="form-control mb-4"
                                                                     id="phone"
                                                                      placeholder="Ingrese su numero de teléfono" 
                                                                      value={infoUser.telefono||"" }
                                                                      onChange={(e) => handleInfo(e, "telefono") }
                                                                      />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label htmlFor="email">Email</label>
                                                                    <input type="text" 
                                                                    readOnly
                                                                    className="form-control mb-4"
                                                                     id="email"
                                                                      placeholder="Ingrese su email" 
                                                                      value={infoUser.email || ""} 
                                                                    //   onChange={(e) => handleInfo(e, "email") }
                                                                      disabled
                                                                      />
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="account-settings-footer">

                            <div className="as-footer-container d-flex align-items-center flex-column">
                            <button id="multiple-reset" className="btn btn-success btn-lg" onClick={() => guardarCambios()}>Guardar Cambios</button>

                            {msgSubmit.includes("La información ha sido actualizada")?
                                <ModalSuccessChanges
                                mensaje={msgSubmit}
                            />
                            :
                            <span className={`${msgSubmit.includes("Error")? "text-danger" : "text-success"} ml-1 mt-3`}>
                                {`${msgSubmit}`}
                            </span>
                        }
                            </div>
                        </div>
                    </div>
                </div>
            : <Loading/>
        }
        </div> 
        </>
    )

//funciones
async function cambiarInformacionUsuario (idUsuario: number, infoUser: USUARIO) {
    const response =  await axios.put(`${baseURL}USUARIO/${idUsuario}`,infoUser, headers)
    .then((el: AxiosResponse<IApiResponse<USUARIO>>) => el.data)
    return response
  }
}


export default ContentPerfil